import React from "react";
import { EditableField } from "../EditableField";

interface ActionItemDescriptionProps {
  description: string;
  onChange: (value: string) => void;
}

export function ActionItemDescription({ description, onChange }: ActionItemDescriptionProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-foreground">Description</h2>
      <EditableField
        value={description}
        onChange={onChange}
        type="textarea"
        placeholder="Add a description..."
        showToast={true}
        className="bg-background text-foreground"
      />
    </div>
  );
}